import type {
  DirectedTripleWithFilters,
  MetaModelTriple,
} from '@ardoq/api-types';
import { anyType } from '@ardoq/global-consts';
import { metaModelOperations } from 'architectureModel/metaModelOperations';

/**
 * A hop from the hierarchy node: the sentinel on exactly one endpoint and a
 * concrete reference type. It stands for the hierarchy types' own triples,
 * which is how `getRawGraphEdge` resolves it.
 */
const isHierarchyHopTriple = ({
  sourceComponentType,
  referenceType,
  targetComponentType,
}: MetaModelTriple): boolean =>
  referenceType !== anyType &&
  (sourceComponentType === anyType) !== (targetComponentType === anyType);

export const getTriplesFromPathsWithoutHierarchyHops = (
  paths: DirectedTripleWithFilters[][]
): MetaModelTriple[] =>
  metaModelOperations
    .getTriplesFromPaths(paths)
    .filter(triple => !isHierarchyHopTriple(triple));
